import { render, staticRenderFns } from "./HotelRoomType.vue?vue&type=template&id=5dfcfb4f&"
import script from "./HotelRoomType.vue?vue&type=script&lang=js&"
export * from "./HotelRoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports